<lib-success-check-animation-icon></lib-success-check-animation-icon>

@if(text) {
<div class="text">{{ text | translate }}</div>
<lib-spacer></lib-spacer>
} @if(textHtml) {
<div class="text" [innerHTML]="textHtml"></div>
<lib-spacer></lib-spacer>
} @if(showCountDownBar) {
<mat-progress-bar
  mode="determinate"
  [value]="countDownBarProcess"
></mat-progress-bar>
}
